import React from "react";
import styled from "styled-components";
import PopupLink from "../../PopupLink";

// Util
function createMarkup(str) {
  return { __html: str };
}

// Styled components
const MainHeader = styled.h1`
  font-size: 1.5em;
`;
const Content = styled.div`
  font-size: 14px;
  margin-bottom: 5px;
`;

const PopupContent = ({ popUpContent }) => (
  <div>
    <MainHeader> {popUpContent.title} </MainHeader>
    {Object.values(popUpContent.paragraph_data).map(paragraph => (
      <Content dangerouslySetInnerHTML={createMarkup(paragraph)} />
    ))}
  </div>
);

// Rendered Component
const DynamicPopupLink = ({ popUpContent, linkText }) => {
  return (
    <PopupLink
      linkText={linkText}
      popupContent={<PopupContent popUpContent={popUpContent} />}
    />
  );
};

export default DynamicPopupLink;



// WEBPACK FOOTER //
// ./src/components/ImportantInformationFlightLookup/DynamicPopupLink/index.js